import { render, staticRenderFns } from "./BDXWizardSaveButton.vue?vue&type=template&id=5b69d120"
import script from "./BDXWizardSaveButton.vue?vue&type=script&lang=js"
export * from "./BDXWizardSaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports